import request from '@/utils/request'

export function balanceDetailsPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/balanceDetailsPage',
    method: 'get',
    params: query
  })
}

export function postFavoritesPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/postFavoritesPage',
    method: 'get',
    params: query
  })
}

export function productFavoritesPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/productFavoritesPage',
    method: 'get',
    params: query
  })
}

export function userAddressPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/userAddressPage',
    method: 'get',
    params: query
  })
}

export function withdrawalRecordsPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/withdrawalRecordsPage',
    method: 'get',
    params: query
  })
}

export function postListPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/postListPage',
    method: 'get',
    params: query
  })
}

export function shoppingCartPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/shoppingCartPage',
    method: 'get',
    params: query
  })
}

export function withdrawalAccountPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/withdrawalAccountPage',
    method: 'get',
    params: query
  })
}

export function userAssetsPageUserDetail(query) {
  return request({
    url: '/biz/user/detail/userAssetsPage',
    method: 'get',
    params: query
  })
}
